import CeleroTerminalsHtml from './celero.terminals.html';

export function CeleroTerminalsDirective () {
  return {
    controller: 'CeleroTerminalsCtrl',
    restrict  : 'E',
    scope     : {
      settings : '=',
      terminals: '='
    },
    templateUrl: CeleroTerminalsHtml
  };
}
